export const INPUT_FIELDS = {
  Hidden: "ContentfulFormInputFieldHidden",
  Select: "ContentfulFormInputFieldSelect",
  SideBySide: "ContentfulFormInputFieldSideBySide",
  Text: "ContentfulFormInputFieldText",
}

// Attachment upload (Refer-a-Patient referral form)
export const ATTACHMENT_LABEL = "Attachment(s) - Limit 5"
export const ATTACHMENT_MAX_FILES = 5
export const ATTACHMENT_MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB per file
export const ATTACHMENT_ACCEPTED_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/png",
]
export const ATTACHMENT_ACCEPT_ATTR = ".pdf,.jpg,.jpeg,.png"
